import React, { useContext, useEffect, useRef, useState } from 'react';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { useDispatch, useSelector } from 'react-redux';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import SearchIcon from '../../../../../Assets/Modals/SearchIcon.svg';
import ProductCard from './ProductCard';
import { closeModal } from '../../../../../Features/couponsSlice';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { AddCouponFormContext } from '../../../../../Context/Coupons/AddCouponFormContext';

function SelectProducts() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    const inventoryProducts = useSelector((state) => state.inventoryManagement.products.products);

    const { selectedProducts, setSelectedProducts, setSelectionType, setSelectedCategory, selectedCollection, setSelectedCollection, selectedCustomCollection, setSelectedCustomCollection } = useContext(AddCouponFormContext);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const [searchType, setSearchType] = useState('products');
    const [searchInputValue, setSearchInputValue] = useState('');
    const [selectedProductsList, setSelectedProductsList] = useState([]);
    const [list, setList] = useState([]);

    const handleChange = (e) => {
        setSearchInputValue(e.target.value);
    }

    const handleKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(searchType === 'products') {
                const filteredList = inventoryProducts.filter(item => item.product.status !== 'Draft').filter(product => product.product.productName.toLowerCase().includes(searchInputValue.toLowerCase()))
                setList(filteredList);
            }
            else {
                const filteredList = inventoryProducts.filter(item => item.product.status !== 'Draft').filter(
                    product => product.product.Tag.some(tag =>
                        tag.toLowerCase().includes(searchInputValue.toLowerCase())
                    )
                );
                setList(filteredList);
            }
        }
    }

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const handleNextClick = () => {
        if(selectedProductsList.length > 0) {
            setSelectedProducts(selectedProductsList);
            setSelectionType('product');
            if(Object.keys(selectedCollection).length > 0) {
                setSelectedCategory({});
                setSelectedCollection({});
            }
            if(Object.keys(selectedCustomCollection).length > 0) {
                setSelectedCustomCollection({});
            }
            dispatch(closeModal());
        }
        else {
            showToast('Select products before proceeding', 'warning');
        }
    }

    const toggleSearchType = () => {
        if(searchType === 'tags') {
            setSearchType('products');
        }
        else {
            setSearchType('tags');
        }
    }

    const addProductHandler = (item) => {
        setSelectedProductsList([ ...selectedProductsList, item ])
    }

    const removeProductHandler = (item) => {
        setSelectedProductsList(selectedProductsList.filter(product => product.product.id !== item.product.id));
    }

    useEffect(() => {
        setList(inventoryProducts.filter(item => item.product.status !== 'Draft'));
    }, [inventoryProducts]);

    useEffect(() => {
        if(selectedProducts?.length > 0) {
            setSelectedProductsList(selectedProducts);
        }
    }, [selectedProducts]);

    return (
        <div ref={wrapperRef} className="w-[91%] h-[90%] bg-[#FFFFFF] rounded-xl overflow-hidden p-6 flex flex-col gap-3 relative">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Add Products</h1>

                <button onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <div className="flex flex-col">
                <div className="border border-[#EAEAEA] bg-[#F5F5F5] rounded-lg p-4 flex items-center gap-1 focus-within:border-primaryColor">
                    <div className="w-6 h-6 flex items-center justify-center">
                        <img src={SearchIcon} alt="Search Icon" />
                    </div>

                    <input 
                        value={searchInputValue} 
                        onChange={handleChange} 
                        onKeyDown={handleKeyDown} 
                        placeholder={`Search by ${searchType}`} 
                        className='w-[calc(100%-24px)] outline-none bg-transparent font-urbanist-regular font-medium text-base placeholder:text-[#666666]' 
                        type="text" 
                    />
                </div>

                <div className="p-[10px]">
                    <button 
                        className='text-[#1055EB] outline-none font-urbanist-regular font-medium text-base underline decoration-1' 
                        onClick={toggleSearchType}
                    >search by {searchType === 'tags' ? 'products': 'tags'}</button>
                </div>
            </div>

            <div className="max-h-[100%] grid grid-cols-5 gap-x-3 gap-y-3 max-[1280px]:grid-cols-4 max-[1152px]:grid-cols-3 overflow-y-scroll no-scrollbar pb-20">
                {list?.map(product => {
                    const isSelected = selectedProductsList.some(item => item.product.id === product.product.id);

                    return (
                        <ProductCard 
                            key={product.product.id} 
                            product={product} 
                            addProductToList={val => addProductHandler(val)} 
                            removeProductFromList={val => removeProductHandler(val)} 
                            selected={isSelected} 
                        />
                    )
                })}
            </div>

            <div className="bg-[#FFFFFF] absolute w-full right-0 bottom-0 flex items-center justify-between p-6 shadow-[-9px_0px_18px_0px_#00000033]">
                {/* <p className='font-urbanits-regular font-normal text-[14px] leading-[22px] text-[#121212]'>Note: In the next step, you'll see all available variants for your chosen products. Feel free to deselect any variant you prefer not to include in your bundle. It's all about crafting the perfect offer for your shoppers!</p> */}
            
                <button onClick={handleNextClick} className={`px-4 py-2 ml-auto rounded font-urbanist-regular font-semibold text-base text-center text-buttonText ${selectedProductsList.length ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'}`} type='button'>
                    Next
                </button>
            </div>
        </div>
    );
}

export default SelectProducts;
